import React, { useState } from "react";
import { FiEdit, FiExternalLink, FiImage, FiInfo, FiTrash2, FiCalendar } from "react-icons/fi";
import {
  cleanText,
  getCatalogDate,
  getCatalogMedia,
  getCatalogPrice,
  getWebsiteHref,
} from "./catalogUtils";

const CLAMP_STYLE = { display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical", overflow: "hidden" };

const CatalogCard = ({ catalog, canManage, busy, onView, onEdit, onDelete }) => {
  const [imageFailed, setImageFailed] = useState(false);
  const cover = getCatalogMedia(catalog).find((item) => !item.isVideo);
  const category = cleanText(catalog?.type?.name);
  const price = getCatalogPrice(catalog);
  const description = cleanText(catalog?.description);
  const createdOn = getCatalogDate(catalog);
  const website = getWebsiteHref(catalog?.url);

  return (
    <article className="card h-100 border-0 shadow-sm rounded-3 overflow-hidden">
      {cover && !imageFailed ? (
        <img
          src={cover.url}
          alt={category ? `${category} catalog` : "Catalog"}
          className="w-100 object-fit-cover"
          style={{ height: 180 }}
          loading="lazy"
          onError={() => setImageFailed(true)}
        />
      ) : (
        <div
          className="w-100 bg-secondary bg-opacity-10 d-flex align-items-center justify-content-center text-muted"
          style={{ height: 180 }}
          role="img"
          aria-label="No image available"
        >
          <FiImage size={36} aria-hidden="true" />
        </div>
      )}

      <div className="card-body d-flex flex-column p-3">
        <div className="d-flex justify-content-between align-items-start gap-2 mb-2">
          {category && <span className="badge bg-primary bg-opacity-10 text-primary">{category}</span>}
          <span className="fw-bold text-dark small ms-auto text-end">{price || "Price on request"}</span>
        </div>
        {description && (
          <p className="text-secondary small mb-2" style={CLAMP_STYLE}>
            {description}
          </p>
        )}
        {createdOn && (
          <p className="text-muted small mb-2 d-flex align-items-center gap-1">
            <FiCalendar size={12} aria-hidden="true" /> Added {createdOn}
          </p>
        )}
        {website && (
          <a
            href={website}
            target="_blank"
            rel="noreferrer noopener"
            className="small text-primary d-inline-flex align-items-center gap-1 text-decoration-none mb-2"
          >
            <FiExternalLink size={12} aria-hidden="true" /> Portfolio link
          </a>
        )}

        <div className="d-flex gap-2 mt-auto pt-2 border-top">
          <button type="button" className="btn btn-outline-secondary btn-sm flex-grow-1" onClick={() => onView(catalog)}>
            <FiInfo size={13} aria-hidden="true" /> View
          </button>
          {canManage && (
            <>
              <button type="button" className="btn btn-outline-primary btn-sm flex-grow-1" onClick={() => onEdit(catalog)} disabled={busy}>
                <FiEdit size={13} aria-hidden="true" /> Edit
              </button>
              <button
                type="button"
                className="btn btn-outline-danger btn-sm"
                onClick={() => onDelete(catalog)}
                disabled={busy}
                aria-label="Delete catalog"
              >
                <FiTrash2 size={13} aria-hidden="true" />
              </button>
            </>
          )}
        </div>
      </div>
    </article>
  );
};

export default CatalogCard;
